// @ts-check
import React from 'react';
import { connect } from 'react-redux';
import { Sidebar } from 'shared/containers/portal_layout';
import { newReferralButtonClicked } from '../../../actions/NewReferralActions';

const StaffSidebarLinks = ({ dispatch, currentEmployment, pendingReferralsCount }) => (
  <Sidebar>
    <Sidebar.NavLink path="/a/portal/dashboard" label="Dashboard" icon="home" />
    <Sidebar.NavLink
      path="/a/portal/passive_app_notifications/unread"
      label="Notifications"
      icon="bullhorn"
    />

    {currentEmployment.features.indexOf('index_patient_members') >= 0 && (
      <Sidebar.NavLink path="/a/portal/patient_members" label="Patients" icon="group" />
    )}

    {/* TODO: Add once this page has a provider select
    <Sidebar.NavLink
      path="/a/portal/cost_estimates/new"
      label="Cost Estimate"
      icon="barcode"
    />
    */}

    <Sidebar.NavLink path={`/a/calendar`} label="Calendar" icon="calendar" />
    <Sidebar.Submenu icon="drawer2" label="Referrals" numberBadge={pendingReferralsCount}>
      <Sidebar.Submenu.NavFakeLink
        onClick={() => dispatch(newReferralButtonClicked())}
        label="Create Referral"
      />
      <Sidebar.Submenu.NavLink path={`/a/portal/referrals`} label="My Referrals" />
    </Sidebar.Submenu>

    <Sidebar.NavLink
      path="/a/portal/eligibility_checks/new"
      label="Eligibility Check"
      icon="coin-dollar"
    />

    {currentEmployment.features.indexOf('analytics') >= 0 && (
      <Sidebar.NavLink path={`/a/analytics`} label="Analytics" icon="graph" />
    )}

    {currentEmployment.features.indexOf('manage_staff') >= 0 && (
      <Sidebar.NavLink
        path={`/a/portal/organizations/${currentEmployment.organizationId}/users`}
        label="Users"
        icon="user"
      />
    )}

    {currentEmployment.features.indexOf('manage_staff') >= 0 && (
      <Sidebar.NavLink
        path={`/a/portal/organizations/${currentEmployment.organizationId}/providers`}
        label="Providers"
        icon="aid-kit"
      />
    )}

    {currentEmployment.features.indexOf('manage_subscription') >= 0 &&
    currentEmployment.showSubscriptionLink ? (
      <Sidebar.NavLink path="/a/portal/subscribe" label="Subscribe" icon="coin-dollar" />
    ) : null}

    {currentEmployment.features.indexOf('entities') >= 0 ? (
      <Sidebar.NavLink path="/a/portal/entity_settings" label="Organization Settings" icon="gear" />
    ) : null}
  </Sidebar>
);

export default connect()(StaffSidebarLinks);
